import { render, staticRenderFns } from "./registrationClient.vue?vue&type=template&id=cf8aed9e&scoped=true"
import script from "./registrationClient.vue?vue&type=script&lang=js"
export * from "./registrationClient.vue?vue&type=script&lang=js"
import style0 from "./registrationClient.vue?vue&type=style&index=0&id=cf8aed9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8aed9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VImg,VTextField})
